import React from 'react';
import { Outlet } from 'react-router-dom';

const NewsLayout: React.FC = () => {
  return (
    <div className="flex flex-col gap-1 w-full max-w-screen-xl mx-auto px-2 py-2">
      <Outlet />
    </div>
  );
};

export default NewsLayout;
